// extracted by mini-css-extract-plugin
export var column = "InfoGrid-module--column--VnRYf";
export var infoGrid = "InfoGrid-module--infoGrid--JuLV7";
export var infoLabel = "InfoGrid-module--infoLabel--i8kTr";
export var infoValue = "InfoGrid-module--infoValue --0kuaY";